<template>
  <div class="center-content login-background">
    <div class="title-frame">
      <h1 class="title">Acroファイル交換サービス</h1>
    </div>
    <div class="login-card">
      <div class="ui segment frame">
        <i class="massive user circle icon"></i>
        <h2>ファイル交換ログイン</h2>

        <!-- エラーメッセージ -->
        <div class="ui error message frame" v-show="errorMessageList.length !== 0">
          <ul class="list">
            <li v-for="(message, index) in errorMessageList" :key="index">{{message}}</li>
          </ul>
        </div>

        <!-- 入力フォーム -->
        <form id="receiverLogin-form" class="ui large form frame" @submit.prevent="login">
          <div class="field" :class="{ 'error': $v.exchangeId.$error }">
            <div class="ui left icon input">
              <i class="exchange icon"></i>
              <input
                id="receiverLogin-form__exchange-id"
                v-model.trim="$v.exchangeId.$model"
                type="text"
                name="exchangeId"
                placeholder="交換ID"
              >
            </div>
          </div>
          <div class="error" v-if="$v.exchangeId.$error && !$v.exchangeId.required">交換IDを入力してください</div>

          <div class="field" :class="{ 'error': $v.email.$error }">
            <div class="ui left icon input">
              <i class="mail icon"></i>
              <input
                id="receiverLogin-form__email"
                v-model.trim="$v.email.$model"
                type="email"
                name="email"
                placeholder="メールアドレス"
              >
            </div>
          </div>
          <div class="error" v-if="$v.email.$error && !$v.email.required">メールアドレスを入力してください</div>
          <div
            class="error"
            v-if="$v.email.$error && $v.email.required && !$v.email.email"
          >E-mail形式で入力してください</div>

          <div class="field" :class="{ 'error': $v.password.$error }">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input
                id="receiverLogin-form__password"
                v-model.trim="$v.password.$model"
                type="password"
                name="password"
                placeholder="パスワード"
              >
            </div>
          </div>
          <div class="error" v-if="$v.password.$error && !$v.password.required">パスワードを入力してください</div>

          <button
            id="receiverLogin-form__submit"
            type="submit"
            class="ui fluid large button blue"
            :class="{'disabled': $v.$invalid}"
          >ログイン</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  title: 'ログイン',
  data: function () {
    return {
      exchangeId: '',
      email: '',
      password: '',
      errorMessageList: []
    }
  },
  validations: {
    exchangeId: {
      required
    },
    password: {
      required
    },
    email: {
      required,
      email
    }
  },
  methods: {
    login: function () {
      this.errorMessageList = []
      var userInfo = {
        'exchangeId': this.exchangeId,
        'email': this.email,
        'password': this.password,
        'errorMessageList': this.errorMessageList
      }
      this.$emit('user-info', userInfo)
    }
  }
}
</script>
<style>
.login-background {
  height: 100%;
  background: linear-gradient(
    0deg,
    #ffffff 0%,
    #ffffff 50%,
    var(--main-color) 50%,
    var(--dark-color) 100%
  );
}

.title {
  font-size: 60px;
  color: #ffffff;
}

.title-frame {
  padding: 5vh;
}

.login-card {
  width: 600px;
  margin: auto;
}

.ui.segment.frame {
  padding: 40px;
}

.massive.user.circle.icon {
  font-size: 10em;
}

.ui.form.frame {
  margin: 30px 40px 30px;
}

.ui.error.message.frame {
  margin: 0 40px;
}
</style>
